import { gql, useMutation } from '@apollo/client';
import { GET_USER } from './useUserQuery';

const LINK_KLAUS_ORG = gql`
  mutation LinkKlausOrg($klausOrgId: String!) {
    linkKlausOrg(klausOrgId: $klausOrgId)
  }
`;

const DISMISS_KLAUS_MERGE_OFFER = gql`
  mutation DismissKlausMergeOffer {
    dismissKlausMergeOffer
  }
`;

/** "Ja" im Merge-Angebot: aktive Firma mit der gewählten Klaus-Org verknüpfen. */
export function useLinkKlausOrgMutation() {
  return useMutation<{ linkKlausOrg: boolean }, { klausOrgId: string }>(LINK_KLAUS_ORG, {
    refetchQueries: [{ query: GET_USER }],
    awaitRefetchQueries: true,
  });
}

/** "Nein" im Merge-Angebot: wird am User gemerkt, die Frage kommt nicht wieder. */
export function useDismissKlausMergeOfferMutation() {
  return useMutation<{ dismissKlausMergeOffer: boolean }>(DISMISS_KLAUS_MERGE_OFFER, {
    refetchQueries: [{ query: GET_USER }],
    awaitRefetchQueries: true,
  });
}
